import Component from '../../../../../pages/vpp/features/highlighted-specs/highlighted-specs-attrs.desktop';

export default Component;
